import { helper } from '@ember/component/helper';
import { USER_ROLES_LABELS, UserRoleType } from 'cio/utils/user-roles';

export function userRoleLabel([role]: [UserRoleType]) {
  return USER_ROLES_LABELS[role];
}

export default helper(userRoleLabel);
